import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose } from 'class-transformer';
import { ArrayNotEmpty, ArrayUnique, IsArray, IsEmail, IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { ToLowerCase } from '../../common/utils';
import { RoleEnum } from '../../role/interface';
import { UserExposeGroup } from '../interface/UserExposeGroup';
export class InviteEmailUserDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [UserExposeGroup.FIXTURE, UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    IsOptional({ always: true }),
    IsString({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    IsNotEmpty({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    __metadata("design:type", String)
], InviteEmailUserDto.prototype, "merchantId", void 0);
__decorate([
    ApiPropertyOptional({ enum: RoleEnum }),
    Expose({ groups: [UserExposeGroup.FIXTURE, UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    IsOptional({ always: true }),
    IsEnum(RoleEnum, { groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    __metadata("design:type", Object)
], InviteEmailUserDto.prototype, "role", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [UserExposeGroup.FIXTURE, UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    IsOptional({ always: true }),
    IsString({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    __metadata("design:type", String)
], InviteEmailUserDto.prototype, "roleV2Uuid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true }),
    Expose({ groups: [UserExposeGroup.FIXTURE, UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    IsOptional({ always: true }),
    IsArray({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    ArrayNotEmpty({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    ArrayUnique({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL] }),
    __metadata("design:type", Object)
], InviteEmailUserDto.prototype, "stores", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [
            UserExposeGroup.FIXTURE,
            UserExposeGroup.READ,
            UserExposeGroup.INVITE_EMAIL,
            UserExposeGroup.CREATE,
            UserExposeGroup.CREATE_SSO,
            UserExposeGroup.RESET_PASSWORD,
        ],
    }),
    IsEmail({}, { groups: [UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.CREATE_SSO, UserExposeGroup.INVITE_EMAIL, UserExposeGroup.RESET_PASSWORD] }),
    ToLowerCase(),
    __metadata("design:type", String)
], InviteEmailUserDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL, UserExposeGroup.INVITE_EMAIL_CONFIRM_FRANCHISE] }),
    IsOptional({ always: true }),
    IsString({ groups: [UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.INVITE_EMAIL, UserExposeGroup.INVITE_EMAIL_CONFIRM_FRANCHISE] }),
    __metadata("design:type", String)
], InviteEmailUserDto.prototype, "templateId", void 0);
//# sourceMappingURL=InviteEmailUserDto.js.map